import { aftersales } from 'types/aftersales';

export const getAOPStatus = (exchangeBookingItems = []) => {
  let isAOPActivated = false;
  let isMaintainPriceActivated = false;

  exchangeBookingItems?.some((bookingItem) => {
    const rules = bookingItem?.afterSalesRules ?? [];

    return rules.some((rule) => {
      isAOPActivated = rule?.type === aftersales.REBOOK && rule?.active === true && rule?.override === true;
      isMaintainPriceActivated = rule?.maintainPrice === true;

      return isAOPActivated;
    });
  });

  return { isAOPActivated, isMaintainPriceActivated };
};

export const findClassOfServiceBeingExchanged = (legs = [], bookingItemRefs = []) =>
  legs.filter((leg) => leg.products?.some((product) => bookingItemRefs?.includes(product.itemRef)))?.map((o) => o.classOfService?.code);
